// Cookie consent utility functions

export interface CookiePreferences {
  essential: boolean;
  analytics: boolean;
  marketing: boolean;
}

// Default preferences (essential cookies are always required)
export const defaultPreferences: CookiePreferences = {
  essential: true,
  analytics: false,
  marketing: false,
};

// Get cookie consent status
export const getCookieConsent = (): boolean => {
  return localStorage.getItem('cookieConsent') === 'true';
};

// Get cookie preferences
export const getCookiePreferences = (): CookiePreferences => {
  const storedPreferences = localStorage.getItem('cookiePreferences');
  if (storedPreferences) {
    try {
      return JSON.parse(storedPreferences);
    } catch (error) {
      console.error('Error parsing cookie preferences:', error);
      return defaultPreferences;
    }
  }
  return defaultPreferences;
};

// Check if a specific cookie type is allowed
export const isCookieAllowed = (type: keyof CookiePreferences): boolean => {
  // Essential cookies are always allowed
  if (type === 'essential') return true;
  
  // If no consent has been given yet, block non-essential cookies
  if (!getCookieConsent()) return false;
  
  // Check specific cookie type preference
  const preferences = getCookiePreferences();
  return preferences[type] || false;
};

// Future implementation for Supabase
// export const storeConsentInSupabase = async (preferences: CookiePreferences) => {
//   try {
//     // This would be implemented when Supabase is integrated
//     // const { data, error } = await supabase
//     //   .from('cookie_consents')
//     //   .insert([
//     //     {
//     //       user_id: 'anonymous', // or actual user_id if authenticated
//     //       timestamp: new Date().toISOString(),
//     //       preferences: preferences,
//     //     },
//     //   ]);
//     
//     // if (error) throw error;
//     // return data;
//   } catch (error) {
//     console.error('Error storing consent in Supabase:', error);
//   }
// };